// extracted by mini-css-extract-plugin
export default {"articles":"articleStyles_articles__Kt7-+","list":"articleStyles_list__GRNE6","card":"articleStyles_card__yU-ua"};